import type { SystemVersionResponse } from "@/types";

const shortHash = (value: string | undefined) => value && value !== "unknown" ? value.slice(0, 12) : "-";

const ChangeHistoryCard = ({ version }: { version: SystemVersionResponse | null }) => {
  const rows = [
    { title: "Git commit", state: shortHash(version?.gitCommit) },
    { title: "Artifact SHA", state: shortHash(version?.artifactSha256) },
    { title: "소스 변경", state: version?.sourceDirty ? "포함" : "없음" },
  ];

  return (
    <div className="bg-white rounded-lg border border-slate-200 shadow-sm p-4 flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-slate-50"><i className="ri-shield-check-line text-slate-500 text-xs" /></div>
        <h4 className="text-xs font-semibold text-slate-700">릴리즈 무결성</h4>
      </div>
      <div className="flex flex-col gap-2">
        {rows.map((row) => (
          <div key={row.title} className="flex items-center justify-between gap-2">
            <span className="text-xs text-slate-600">{row.title}</span>
            <span className="inline-flex max-w-[8.125rem] truncate rounded-full border border-slate-200 bg-slate-50 px-2 py-0.5 text-xs font-medium text-slate-500">{row.state}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChangeHistoryCard;
